import {useEffect, useState} from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import {Eye} from 'lucide-react'
import {Link} from 'react-router-dom'

export const catalogSearchColumns = [
	{key: 'id_promocion', label: 'ID Promoción'},
	{key: 'nombre_promocion', label: 'Nombre Promoción'},
	{key: 'codigo_producto', label: 'Cód. Producto'},
	{key: 'descripcion', label: 'Descripción'},
	{key: 'categoria', label: 'Categoría'},
	{key: 'nombre_cadena', label: 'Cadena'},
	{key: 'tipo_promocion', label: 'Tipo Promoción'},
	{key: 'nombre_fase', label: 'Fase'},
	{key: 'nombre_estado_promocional', label: 'Estado Promocional'},
	{key: 'inicio_sellin', label: 'Inicio Sell-In'},
	{key: 'termino_sellin', label: 'Término Sell-In'},
	{key: 'inicio_sellout', label: 'Inicio Sell-Out'},
	{key: 'termino_sellout', label: 'Término Sell-Out'},
	{key: 'duracion_sellin', label: 'Duración Sell-In'},
	{key: 'duracion_sellout', label: 'Duración Sell-Out'},
	{key: 'precio_lista', label: 'Precio Lista'},
	{key: 'precio_promocion', label: 'Precio Promoción'},
	{key: 'descuento', label: 'Descuento'},
	{key: 'pvp', label: 'PVP'},
	{key: 'mecanica', label: 'Mecánica'},
	{key: 'exhibicion', label: 'Exhibición'},
	{key: 'activacion', label: 'Activación'},
	{key: 'inversion_adicional', label: 'Inversión Adicional'},
	{key: 'promotora', label: 'Promotora'},
	{key: 'publicacion', label: 'Publicación'},
	{key: 'nombre_publicacion', label: 'Nombre Publicación'},
	{key: 'fecha_ingreso', label: 'Fecha Ingreso'},
	{key: 'fecha_actualizacion', label: 'Fecha Actualización'},
	{key: 'id_cadena', label: 'ID Cadena'},
	{key: 'id_fase', label: 'ID Fase'},
	{key: 'id_estado_promocional', label: 'ID Estado Promocional'},
]

export const isRejectedChangeRequest = (promo) => {
	const phase = String(promo.nombre_fase || '').toLowerCase()
	const state = String(promo.nombre_estado_promocional || '').toLowerCase()
	return phase.includes('edici') && state === 'con cambios'
}

export const getCatalogSearchRowClassName = (promo) => {
	const state = String(promo.nombre_estado_promocional || '').toLowerCase()
	const phase = String(promo.nombre_fase || '').toLowerCase()

	if (isRejectedChangeRequest(promo)) return 'catalog-row-rechazado'
	if (state.includes('sin acuerdo')) return 'catalog-row-sin-acuerdo'
	if (state.includes('rechaz')) return 'catalog-row-rechazado'
	if (phase.includes('ejecuci') || state.includes('ejecuci') || state.includes('por ejecutar')) return 'catalog-row-ejecucion'
	if (phase.includes('negociaci') || state.includes('negociaci')) return 'catalog-row-negociacion'
	return ''
}

export const CatalogTable = ({
	data = [],
	columns = catalogSearchColumns,
	tableId = 'catalog-search-table',
	onPromotionClick,
	onProductClick,
}) => {
	const [height, setHeight] = useState(0)

	useEffect(() => {
		const handleResizeWork = () => {
			setHeight(Math.max(window.innerHeight - 220, 680))
		}

		window.addEventListener('resize', handleResizeWork)
		handleResizeWork()

		return () => window.removeEventListener('resize', handleResizeWork)
	}, [])

	const formatCellValue = (value, columnKey, promo) => {
		if (columnKey === 'nombre_estado_promocional' && isRejectedChangeRequest(promo)) {
			return 'Rechazado, Solicitud de Cambios'
		}
		if (value === null || value === undefined || value === '') return '-'
		return value
	}

	const getCatalogPath = (promo) => `/catalogo/${promo.id_promocion}/${promo.id_estado_promocional || promo.id_fase || 1}`

	return (
		<TableContainer className='catalog-search-table-container' component={Paper} style={{height}}>
			<Table id={tableId} sx={{minWidth: 1800}} aria-label='historial promocional' stickyHeader>
				<TableHead>
					<TableRow>
						<TableCell>Ver</TableCell>
						{columns.map((column) => (
							<TableCell key={column.key}>{column.label}</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody className='table-catalog-search'>
					{data.map((promo, index) => (
						<TableRow className={getCatalogSearchRowClassName(promo)} key={`${promo.id_promocion || 'promo'}-${promo.codigo_producto || 'product'}-${index}`}>
							<TableCell>
								<Link className='catalog-search-view-link' to={getCatalogPath(promo)} title='Ver catálogo'>
									<Eye size={16} />
								</Link>
							</TableCell>
							{columns.map((column) => (
								<TableCell key={column.key}>
									{column.key === 'id_promocion' ? (
										<button
											type='button'
											className='catalog-search-id-link'
											onClick={() => onPromotionClick && onPromotionClick(promo)}
											title='Abrir Tarjeta PF'
										>
											{formatCellValue(promo[column.key], column.key, promo)}
										</button>
									) : column.key === 'codigo_producto' ? (
										<button
											type='button'
											className='catalog-search-product-link'
											onClick={() => onProductClick && onProductClick(promo)}
											title='Ver producto'
										>
											{formatCellValue(promo[column.key], column.key, promo)}
										</button>
									) : (
										formatCellValue(promo[column.key], column.key, promo)
									)}
								</TableCell>
							))}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	)
}
